import { useCallback } from 'react';

export const useUpdateAnnotations = (callbacks: ((annotations: string[]) => void)[]) =>
	useCallback((annotationsList: string[]) => {
		callbacks.forEach((callback) => callback(annotationsList));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, callbacks);
